<div [class]="wrapperClass()">
  <!-- Label -->
  @if (label()) {
    <label class="form-label fw-medium text-slate-700 mb-2" [for]="fieldId()">
      {{ label() | translate }}
      @if (required()) {
        <span class="text-danger">*</span>
      }
    </label>
  }

  @if (showPrefixIcon()) {
    <!-- Layout có prefix icon (login style) -->
    <div class="input-wrapper">
      <div class="input-icon">
        <svg lucideLock class="icon-sm"></svg>
      </div>
      <input
        [type]="showPassword() ? 'text' : 'password'"
        [id]="fieldId()"
        class="form-control"
        [placeholder]="placeholder() | translate"
        [formField]="field()"
        [attr.autocomplete]="autocomplete()"
      />
      <button
        type="button"
        class="password-toggle"
        (click)="toggleVisibility()"
        tabindex="-1"
      >
        <svg [lucideIcon]="passwordIcon()" class="icon-sm"></svg>
      </button>
    </div>
  } @else {
    <!-- Layout chuẩn (cùng chiều cao với form-control thường) -->
    <div class="position-relative">
      <input
        [type]="showPassword() ? 'text' : 'password'"
        [id]="fieldId()"
        class="form-control"
        [placeholder]="placeholder() | translate"
        [formField]="field()"
        [attr.autocomplete]="autocomplete()"
      />
      <button
        type="button"
        class="btn-toggle position-absolute top-50 end-0 translate-middle-y me-2 p-0 border-0 bg-transparent d-flex align-items-center"
        (click)="toggleVisibility()"
        tabindex="-1"
      >
        <svg
          [lucideIcon]="passwordIcon()"
          [size]="18"
          class="text-secondary opacity-75"
        ></svg>
      </button>
    </div>
  }

  <!-- Validation errors -->
  <app-form-errors [control]="field()()"></app-form-errors>
</div>
